import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

export const incidentsRequireConfirmation = [
  RugbyLeagueIncidentId.Try,
  RugbyLeagueIncidentId.PenaltyTry,
  RugbyLeagueIncidentId.ConversionGoal,
  RugbyLeagueIncidentId.ConversionMissed,
  RugbyLeagueIncidentId.PenaltyKickGoal,
  RugbyLeagueIncidentId.PenaltyKickMissed,
  RugbyLeagueIncidentId.DropGoal,
]
